import { MatchSliceState } from '../matchSliceTypes';
import MatchEvent from '../../../interfaces/matchEvent';
import { MatchEventType } from '../../../enums/matchEventType';

export default function (state: MatchSliceState, matchEvent: MatchEvent): void {
  const { homeTeam, awayTeam } = state.match;

  if (
    matchEvent.matchEventTypeId === MatchEventType.PLAYER_OFF ||
    matchEvent.matchEventTypeId === MatchEventType.PLAYER_ON
  ) {
    if (!matchEvent.team) throw 'No team attached to goal matchEvent (4)';

    const persons = matchEvent.team.id === homeTeam.id ? homeTeam.persons : awayTeam.persons;
    if (matchEvent.matchEventTypeId === MatchEventType.PLAYER_OFF) {
      persons.forEach((personInMatch) => {
        if (matchEvent.person && personInMatch.personId === matchEvent.person.id) {
          personInMatch.currentlyOnTheField = false;
          personInMatch.leavesFieldMinute = matchEvent.time ? matchEvent.time : null;
        }
      });
    } else if (matchEvent.matchEventTypeId === MatchEventType.PLAYER_ON) {
      persons.forEach((personInMatch) => {
        if (matchEvent.person && personInMatch.personId === matchEvent.person.id) {
          personInMatch.currentlyOnTheField = true;
          personInMatch.entersFieldMinute = matchEvent.time ? matchEvent.time : null;
        }
      });
    }
  }
}
